import model3 from '../teslaicons/model3.svg?raw';
import modely from '../teslaicons/modely.svg?raw';
import cybertruck from '../teslaicons/cybertruck.svg?raw';
import models from '../teslaicons/models.svg?raw';
import modelx from '../teslaicons/modelx.svg?raw';

export const CAR_SHAPES = [
  { id: 'model3', name: 'Model 3', short: '3' },
  { id: 'modely', name: 'Model Y', short: 'Y' },
  { id: 'cybertruck', name: 'Cybertruck', short: 'CT' },
  { id: 'models', name: 'Model S', short: 'S' },
  { id: 'modelx', name: 'Model X', short: 'X' },
  { id: 'plain', name: 'Plain car', short: 'Car' },
] as const;

export type CarShape = (typeof CAR_SHAPES)[number]['id'];

export const DEFAULT_CAR_SHAPE: CarShape = 'modely';

const TESLA_SHAPES: Record<Exclude<CarShape, 'plain'>, string> = {
  model3,
  modely,
  cybertruck,
  models,
  modelx,
};

export function isCarShape(value: unknown): value is CarShape {
  return typeof value === 'string' && CAR_SHAPES.some(shape => shape.id === value);
}

/** Only a #rrggbb paint can land in the SVG style attribute. */
export function carPaintColor(color: string): string {
  return /^#[0-9a-fA-F]{6}$/.test(color) ? color : '#2456ff';
}

/**
 * 32×32 marker SVG. Tesla shapes use currentColor, so the color has to be
 * set on the element. Ids are stripped because every car on the map would
 * otherwise reuse body/cabin/glass.
 */
export function carMarkerSvg(shape: CarShape, color: string): string {
  const paint = carPaintColor(color);
  if (shape === 'plain') {
    return `<svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" class="car-icon-svg">
    <path d="M16 3 L22 12 L21 27 L11 27 L10 12 Z" fill="${paint}" opacity="0.95"/>
    <path d="M16 6 L20 13 L12 13 Z" fill="white" opacity="0.4"/>
    <rect x="12" y="15" width="8" height="7" rx="1" fill="white" opacity="0.18"/>
  </svg>`;
  }
  return TESLA_SHAPES[shape]
    .replace(/\sid="[^"]*"/g, '')
    .replace(
      '<svg ',
      `<svg width="32" height="32" style="color:${paint}" `,
    );
}
